import {atom} from "recoil";

// {
//     cardUuid: state.cardUuid,
//     oauthProvider: state.oauthProvider,
//     oauthAccessToken: state.oauthAccessToken,
//     agreementTermsOfService: null,
// }
export const signUpSessionState = atom({
    key: 'signUpSessionState',
    default: null,
});